<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <b-row style="max-width: 100%" class="padding-ten-tb">
      <b-col cols="12">
        <h5 class="color-gray">{{ pageTitle }}</h5>
      </b-col>
    </b-row>

    <OperacionesTab />
  </div>
</template>

<script>
import OperacionesTab from "@/components/Operaciones/OperacionesTab.vue";
import { MESSAGES } from "@/services/operaciones/operaciones.constants";
import { isProveedor } from "@/constants/perfiles";
import { mapState } from "vuex";

import "@/styles/operaciones/operaciones.css";

export default {
  name: "LiquidacionesOperacionesView",

  components: {
    OperacionesTab,
  },

  computed: {
    ...mapState("module", ["perfil"]),
    pageTitle() {
      return MESSAGES.PAGE_TITLE;
    },
  },

  mounted() {
    if (isProveedor(this.perfil)) {
      this.$router.replace({ name: "BlockedPage" });
    }
  },
};
</script>
